const t = (...n) => n.map((r) => r === 0 ? 0 : `${r * 4}px`).join(" ");
export {
  t as spacing
};
